import { render, staticRenderFns } from "./choseStaff.vue?vue&type=template&id=e7880a0e&scoped=true&"
import script from "./choseStaff.vue?vue&type=script&lang=ts&"
export * from "./choseStaff.vue?vue&type=script&lang=ts&"
import style1 from "./choseStaff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7880a0e",
  null
  
)

export default component.exports